export default __webpack_public_path__ + "static/media/Cookie.c2eb043f.png";